import React, { Component } from 'react';
import ExhibitionSlider from './ExhibitionSlider';
import sortChaptersById from './sortChaptersById';

class Exhibition extends Component {
  componentWillMount() {
    const chapterIds = this.props.exhibitionData.edges[0].node.chapters;
    const chapters = this.props.chapterData.edges.map(edge => edge.node);
    this.sortedChapters = sortChaptersById(chapterIds, chapters);
  }
  shouldHide() {
    const exhibitionPath = this.props.exhibitionData.edges[0].node.path;
    return this.props.location.pathname.indexOf(exhibitionPath) === -1;
  }
  render() {
    return (
      <ExhibitionSlider
        {...this.props.layoutFunctions}
        location={this.props.location}
        exhibitionPath={this.props.exhibitionData.edges[0].node.path}
        slides={this.sortedChapters}
        registerNextSlideWithPixi={this.props.registerNextSlideWithPixi}
        registerNextSlide={this.props.registerNextSlide}
        registerHideSliderText={this.props.registerHideSliderText}
        hidden={this.shouldHide()}
        introIsShowing={this.props.introIsShowing}
        exhibitionRouteStatus={this.props.exhibitionRouteStatus}
      />
    );
  }
}

export default Exhibition;



// WEBPACK FOOTER //
// ./src/components/exhibition/index.js